import api from "./api";

class AppService {
  getPage(keyName, locale) {
    return api.get("/app/page", {
      params: { key_name: keyName, locale },
    });
  }

  requestUserRemoval(email) {
    return api.post("/app/user/removal/request", {
      email,
    });
  }

  requestFeedback(payload) {
    return api.post("/app/feedback", payload);
  }
}

export default new AppService();
